import { Dropdown, SelectProps } from 'antd';
import React, { useEffect, useMemo, useState } from 'react';
interface CustomDropdownProps extends SelectProps {
  title?: string;
  width?: string;
  height?: string | number;
  background?: string;
  options?: {
    label: string;
    value: string;
    checked?: boolean;
  }[];
  defaultKey?: string | number;
  disabled?: boolean;
  required?: boolean;
  checkBox?: boolean;
  defaultBorder?: string;
  error?: any;
  onSelect?: (v: string) => void;
  onCheckBox?: (v: any) => void;
  dataForCheckbox?: any;
  render?: string;
  color?: string;
  dropdownArrow?: boolean;
  lineClamp?: boolean;
  fontSize?: string | number;
  fontSelect?: string | number;
  showIconWhenDisabled?: boolean;
}
const CustomDropdown: React.FC<CustomDropdownProps> = ({
  title,
  lineClamp,
  options,
  width,
  disabled,
  required,
  onSelect,
  height,
  checkBox,
  defaultBorder,
  defaultKey,
  error,
  onCheckBox,
  dataForCheckbox,
  background,
  render,
  color,
  fontSize,
  fontSelect,
  showIconWhenDisabled,
  ...props
}) => {
  const [state, setState] = useState({
    selectedKey: undefined,
    show: false as boolean,
  });
  const { selectedKey, show } = state;
  const CustomSelectStyle = {
    cursor: `${disabled ? 'not-allowed' : 'pointer'}`,
    background: `${
      disabled && height !== '39px'
        ? '#E4E4E4'
        : background
        ? background
        : defaultKey === 'done'
        ? '#29B461'
        : defaultKey === 'in_progress'
        ? '#104FAE'
        : defaultKey === 'to_do'
        ? '#445470'
        : '#fff'
    }`,
    border: `${
      disabled
        ? 'none'
        : error
        ? '0.5px solid red'
        : defaultKey === 'done'
        ? '0.5px solid #29B461'
        : defaultKey === 'in_progress'
        ? '0.5px solid #104FAE'
        : defaultKey === 'to_do'
        ? '0.5px solid #445470'
        : '0.5px solid #407FDD'
    }`,
    borderRadius: defaultBorder ? defaultBorder : '10px',
    // boxShadow: '0px 2px 8px rgba(14, 48, 99, 0.25)',
    width: width,
    height: height ? height : 60,
    color: `${color ? color : 'black'}`,
    // opacity: disabled && '0.7',
  };
  const onClick = (key: string, label: string) => {
    setState((p) => ({ ...p, selectedKey: key }));
  };

  const items = options?.map(
    (item: { label: string; value: string; checked?: boolean }) => ({
      label: item?.label,
      key: item?.value,
      checked: item?.checked ? item.checked : false,
    }),
  );
  const selectedValue = useMemo(
    () => options?.find((item) => item?.value === selectedKey)?.label,
    [options, selectedKey],
  );

  useEffect(() => {
    onSelect?.(selectedKey);
  }, [selectedKey]);

  useEffect(() => {
    setState((p) => ({ ...p, selectedKey: defaultKey as string }));
  }, [defaultKey]);

  return (
    <div
      className={'custom_select'}
      style={{ width: width, height: height ? height : 60 }}
    >
      <Dropdown
        trigger={['click']}
        onOpenChange={(open) => setState((pre) => ({ ...pre, show: !show }))}
        open={show}
        {...props}
        dropdownRender={() => (
          <div className="common_custom_dropdown">
            {items?.map((item: any, index: number) => (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  background:
                    item.key === selectedKey && !checkBox
                      ? '#A9CBFF'
                      : 'transparent',
                }}
                className="common_items_dropdown"
                key={index}
                onClick={() => {
                  onClick(item.key, item.label);
                  if (checkBox) {
                    if (onCheckBox) onCheckBox(item.key);
                  } else {
                    setState((pre) => ({ ...pre, show: false }));
                  }
                }}
              >
                <div
                  style={
                    checkBox
                      ? {
                          display: 'flex',
                          gap: 5,
                          fontSize: fontSelect && fontSelect,
                        }
                      : {
                          color:
                            item.label === 'Present'
                              ? '#03D093'
                              : item.label === 'Absent'
                              ? '#D00303'
                              : '',
                          fontWeight:
                            item.label === 'Present' || item.label === 'Absent'
                              ? 600
                              : 400,
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          fontSize: fontSelect && fontSelect,
                        }
                  }
                  className="common_items_select"
                >
                  {(item.label === 'Present' || item.label === 'Absent') && (
                    <div
                      style={{
                        width: '8px',
                        height: '8px',
                        marginRight: 6,
                        marginBottom: 2,
                        borderRadius: '50%',
                        background:
                          item.label === 'Present' ? '#03D093' : '#D00303',
                      }}
                    />
                  )}
                  {checkBox && (
                    <input
                      checked={item?.checked}
                      // onClick={() => (onCheckBox ? onCheckBox(item.key) : null)}
                      type="checkbox"
                    />
                  )}
                  <p style={{ marginTop: fontSelect && 2 }}>{item?.label}</p>
                </div>
              </div>
            ))}
          </div>
        )}
        disabled={disabled}
      >
        <div className="custom_select1" style={CustomSelectStyle}>
          <div style={{ padding: height === '50px' ? '6px 16px' : '8px 16px' }}>
            <div>
              {title && (
                <span
                  style={{
                    color: '#898989',
                    fontSize: '10px',
                    display: 'flex',
                    gap: '4px',
                    marginBottom: '3px',
                    fontWeight: 400,
                  }}
                >
                  {/* {selectedKey? null : title} */}
                  {title}
                  {required && <span style={{ color: '#ed2024' }}>*</span>}
                </span>
              )}
            </div>
            {!disabled || showIconWhenDisabled ? (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  marginTop: title
                    ? '2px'
                    : height === '100%'
                    ? '5px'
                    : height === '39px'
                    ? -2
                    : height === '42px'
                    ? '0px'
                    : '10px',
                }}
              >
                <span
                  style={{
                    color:
                      render === 'Select a model' && height !== 55
                        ? '#898989'
                        : height === '39px'
                        ? '#FFF'
                        : '#000000',
                    fontSize: fontSize && fontSize,
                  }}
                  className={lineClamp && 'line_clamp1'}
                >
                  {dataForCheckbox && dataForCheckbox.length > 0
                    ? `${dataForCheckbox.length} elements selected`
                    : render === ''
                    ? ''
                    : dataForCheckbox && render
                    ? render
                    : render && !selectedValue
                    ? render
                    : selectedValue}
                </span>
                {height === '39px' ? (
                  <img
                    src="/icons/arrow_select_task.svg"
                    alt="arrow"
                    style={{ marginLeft: '10px' }}
                  />
                ) : (
                  <img
                    src="/icons/arrow_select.svg"
                    alt="arrow"
                    style={{ marginLeft: '10px' }}
                  />
                )}
              </div>
            ) : (
              <div
                style={{
                  height: '15px',
                  marginTop: disabled
                    ? title
                      ? '8px'
                      : height === '39px'
                      ? '3px'
                      : '13px'
                    : '10px',
                  display: 'flex',
                  alignItems: 'center',
                  fontSize: fontSize && fontSize,
                  justifyContent:
                    height === '39px' ? 'center' : 'space-between',
                  width: height === '39px' && 90,
                }}
              >
                {selectedValue}
              </div>
            )}
          </div>
        </div>
      </Dropdown>
    </div>
  );
};

export default CustomDropdown;
